import NamedDto from 'modules/base/dto/NamedDto';
import SimulationMonitorLogFieldEditDto from './SimulationMonitorLogFieldEditDto';

export class SimulationMonitorLogEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.tableName = null;
		/** @type {string} */
		this.description = null;
		/** @type {SimulationMonitorLogFieldEditDto[]} */
		this.fields = null;
	}

	/**
	 * @typedef {Object} _SimulationMonitorLogEditDtoProps
	 * @property {string} tableName
	 * @property {string} description
	 * @property {SimulationMonitorLogFieldEditDto[]} fields
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _SimulationMonitorLogEditDtoProps} SimulationMonitorLogEditDtoProps
	 */
	/**
	 *
	 * @param {SimulationMonitorLogEditDtoProps} props
	 * @returns {SimulationMonitorLogEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.tableName = props.tableName;
		this.description = props.description;
		this.fields = props.fields !== null ? props.fields.map(d => new SimulationMonitorLogFieldEditDto().setup(d)) : [];
		return this;
	}
}

export default SimulationMonitorLogEditDto;
